export default {
  setUser(state, payload) {
    state.user = payload;
  },
  setAuthErrors(state, payload) {
    state.errors = payload;
  },
};
